// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imagery-upload .finder-popup {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  z-index: 200;\n}\n.imagery-upload .finder-popup-expanded {\n  bottom: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
